export default `$ gem install foob
Successfully installed foob-0.1.0
1 gem installed
$ foob g
Usage: foob generate [GENERATOR_KEY] [GENERATOR_OPTIONS]

Available Generators:

  command
  domain
  domain-mapper
  local-files-crud-driver
  mcp-connector
  organization
  rack-connector
  redis-crud-driver
  remote-imports
  resque-connector
  resque-scheduler-connector
  ruby-project
  sh-cli-connector
  type
  typescript-react-command-form
  typescript-react-project
  typescript-remote-commands`
